// extracted by mini-css-extract-plugin
export default {"outer":"loader_outer__PRFBW","middle":"loader_middle__UmxjX","rotation":"loader_rotation__FTDW1","inner":"loader_inner__Z3o20"};